import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components/macro";
import Auth from "../../Auth";
import { SudoButton } from "../../sudokit/components/SudoButton";
import { ContentWrapper, Logo, PageWrapper } from "../PageShell";
import { normalizeStyleGuideBetaCampaign } from "../../../../src/shared/styleGuideBetaEnrollment";

const Panel = styled.div`
  padding: 32px;
  border-radius: 20px;
  background: var(--menu-color, #fff);
  color: var(--grey-0);
  box-shadow: var(--card-drop-shadow);
  h1 { margin: 0 0 16px; font-size: 28px; line-height: 1.2; }
  p { margin: 0 0 24px; line-height: 1.6; }
`;

export default function StyleGuideBetaEnrollment({ user }) {
  const { search } = useLocation();
  const campaign = normalizeStyleGuideBetaCampaign(new URLSearchParams(search).get("campaign"));
  const [attempt, setAttempt] = useState(0);
  const [result, setResult] = useState(null);
  const uid = user?.uid;

  useEffect(() => {
    if (!uid || user.isAnonymous) return;
    let cancelled = false;
    setResult(null);
    Auth.fetchWithIdToken("/api/style-guide-beta/enroll", { user, campaign })
      .then((response) => {
        if (!response.success) throw new Error("Enrollment failed");
        if (!cancelled) setResult({ uid, success: true });
      })
      .catch((error) => {
        if (!cancelled) setResult({ uid, success: false, invitationRequired: error.response?.status === 403 });
      });
    return () => { cancelled = true; };
  }, [uid, user, campaign, attempt]);

  const currentResult = result?.uid === uid ? result : null;
  return (
    <PageWrapper>
      <ContentWrapper>
        <Logo />
        <Panel aria-live="polite" aria-busy={!currentResult}>
          {currentResult?.success ? (
            <>
              <h1>You’re in the Style Guide Beta!</h1>
              <p>Style Guide is now available for your account. Open a project and use the style menu at the top to choose or create a style for your writing.</p>
              <SudoButton variant="primary" onClick={() => window.location.assign("/app")}>Start writing</SudoButton>
            </>
          ) : currentResult?.invitationRequired ? (
            <>
              <h1>An invitation is required</h1>
              <p>It looks like this account hasn’t been invited to the Style Guide beta yet. If you received an email, please make sure you’re signed into Sudowrite with the account associated with that email address. Then just click the link in the email again.</p>
              <SudoButton variant="primary" onClick={() => window.location.assign("/app")}>Back to Sudowrite</SudoButton>
            </>
          ) : currentResult ? (
            <>
              <h1>Let’s try that again</h1>
              <p role="alert">Hm! Something went wrong and we couldn’t enable Style Guide beta access. Please check your connection and try again.</p>
              <SudoButton variant="primary" onClick={() => setAttempt((value) => value + 1)}>Try again</SudoButton>
            </>
          ) : (
            <>
              <h1>Joining the Style Guide Beta now…</h1>
              <p>We’re flipping the switch for your account.</p>
            </>
          )}
        </Panel>
      </ContentWrapper>
    </PageWrapper>
  );
}
